import { PawGlyph } from "./paw-glyph";
import {
    hasShelterOperationsContent,
    shelterOperationsRows,
    shelterShowsAtRisk,
} from "../profile/section-content";
import type { Operations } from "../profile/types";

export function ShelterOperationsSection({
    operations,
}: {
    operations: Operations;
}) {
    const rows = shelterOperationsRows(operations);
    const showAtRisk = shelterShowsAtRisk(operations);
    if (!hasShelterOperationsContent(operations)) return null;

    return (
        <section className="lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start lg:gap-x-16">
            <h2 className="text-section-title text-doberman-black text-balance">
                How this shelter works
            </h2>
            <div className="mt-5 lg:mt-0 lg:max-w-190">
                {rows.length > 0 && (
                    <div className="flex flex-col">
                        {rows.map((row, index) => (
                            <div
                                key={row.label}
                                className={`flex items-baseline justify-between gap-4 py-3 ${index > 0 ? "border-t border-doberman-black/8" : ""}`}
                            >
                                <p className="shrink-0 text-body text-doberman-black/60">
                                    {row.label}
                                </p>
                                <p className="text-right text-body text-doberman-black">
                                    {row.value}
                                </p>
                            </div>
                        ))}
                    </div>
                )}
                {showAtRisk && (
                    <div className="mt-5 flex items-start gap-3 rounded-card bg-havanese p-card">
                        <PawGlyph />
                        <p className="text-body-small text-doberman-black/80">
                            Because space is limited, some animals are at risk.
                            Adopting or fostering directly frees a kennel and
                            can save a life.
                            {operations.atRiskListPublished
                                ? " They publish an at-risk list you can help from."
                                : ""}
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}
